/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import Modal from "./Modal";
import messages from "../helpers/messages";

export const Alert = ({
  title = messages.systemError.defaultMessage,
  message,
  handleClose,
  open = true,
  dataTestid,
  large = false,
  singleButton = true,
  handlePrimaryButtonClick,
  handleSecondaryButtonClick,
  primaryButtonCaption,
  secondaryButtonCaption,
  modalStyle,
  singleButtonCaption = messages.close.defaultMessage
}) => (
  <Modal
    title={title}
    open={open}
    handleClose={handleClose}
    titleClass="modal__title_light uppercase"
    closeButtonClass="modal__close-button mr-16 mt-16"
    bodyClass="border-top-grey pl-24 pr-24 pt-16 pb-32"
    modalStyle={modalStyle || { height: undefined }}
    large={large}
  >
    <p data-testid="alert-message" className="mb-24 font-size-16">
      {message}
    </p>
    {singleButton && (
      <div data-testid={dataTestid}>
        <button
          onClick={handleClose}
          className="primary-button fr univers-67-bold-cond mt-12 mb-32"
          data-testid="close-alert-buttton"
        >
          {singleButtonCaption}
        </button>
      </div>
    )}
    {!singleButton && (
      <div>
        <button
          onClick={handlePrimaryButtonClick}
          className="primary-button fr univers-67-bold-cond mt-12 mb-32"
        >
          {primaryButtonCaption}
        </button>
        <button
          onClick={handleSecondaryButtonClick}
          className="secondary-button fr mr-16 univers-67-bold-cond mt-12 mb-32"
        >
          {secondaryButtonCaption}
        </button>
      </div>
    )}
  </Modal>
);

export default Alert;
